export default __webpack_public_path__ + "8b914d4d9d745be17599e87ee129d776.jpg";